"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.content = void 0;
exports.content = {
  en: {
    validation: {
      selectOne: "Please select a value"
    }
  },
  fr: {
    validation: {
      selectOne: "Veuillez sélectionner une valeur"
    }
  },
  es: {
    validation: {
      selectOne: "Por favor seleccione un valor"
    }
  }
};